// handleUnsaveNavigation.ts

import { useNavigationGuard } from "../context/NavigationGuardProvider ";

export const CreateHandleUnsaveNavigation = () => {
  const { showDialog } = useNavigationGuard();

  return (e, showDialogFlag, url, navigate) => {
    if (showDialogFlag) {
      e.preventDefault();
      showDialog(
        () => navigate(`/${url}`),
        () => {} // optional: handle cancel
      );
    } else {
      navigate(`/${url}`);
    }
  };
};
